<app-bootstrap-alert 
  *ngIf="goalTypeOptions[0]?.status?.id === 'Archived'"
  localizationCode="InactiveGoalTypeSelectedWarning" 
  type="danger">
</app-bootstrap-alert>

<div [formGroup]="parentGroup" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openSelectGoalTypeDialog()">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}">
        <mat-label>
            {{ formElement.text }}
        </mat-label>

        <span matSuffix 
          *ngIf="!readOnly && !parentGroup.controls[this.formElement.formControl].disabled && goalTypeOptions.length > 0"
          style="margin-right: 8px;">
          <mat-icon 
            class="material-icons-outlined clickable-icon" 
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); clearSelectedPosition()">close</mat-icon>
        </span>

        <mat-select disableOptionCentering #goalTypeSelect [formControlName]="formElement.formControl" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openSelectGoalTypeDialog()">
              <mat-option></mat-option>

              <ng-container>
                <mat-option *ngFor="let option of goalTypeOptions" [value]="option.id">{{option.name}}</mat-option>
              </ng-container>
        </mat-select>
    </mat-form-field>
</div>
